<template>
  <div class="vue-back-to-top" v-show="visible" @click="backToTop">
    <button type="button" class="btn-to-top">
      <img class="back-to-top-img" :src="require('@/assets/imgs/backtop.png')" />
    </button>
  </div>
</template>
<script>
export default {
  name: "back-to-top",
  data() {
    return {
      visible: false,
      visibleoffset: 1000
    };
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    // this.$refs.adPageRef.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      const currentScroll = window.scrollY;
      const pastTopOffset = currentScroll > this.visibleoffset;
      this.visible = pastTopOffset;
    },

    backToTop() {
      // console.log("backToTop()");
      this.smoothscroll();
      this.$emit("scrolled");
    },

    smoothscroll() {
      let scrollContent = window;
      let currentScroll = window.scrollY;

      setInterval(function() {
        if (currentScroll == 0) return;
        if (currentScroll > 0) {
          currentScroll = Math.max(currentScroll - 100, 0);
          scrollContent.scrollTo(0, Math.floor(currentScroll));
        }
        // console.log(currentScroll);
      }, 1000 / 60);
    }
  }
};
</script>
<style scoped>
.vue-back-to-top {
  z-index: 1;
}

.btn-to-top {
  position: fixed; /* Fixed/sticky position */
  bottom: 2.2rem; /* Place the button at the bottom of the page */
  right: 6.5rem; /* Place the button 30px from the right */
  padding: 0;
  background: transparent;
  border: transparent;
  border-radius: 0.3125rem;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
  overflow: hidden;
  cursor: pointer;
}

.back-to-top-img {
  width: 52px;
  height: 52px;
}
</style>


// WEBPACK FOOTER //
// src/components/fixed/back-to-top.vue